import React from 'react';
import './Footer.scss';

const Footer = () => {
  const ano = new Date().getFullYear();
  return <footer className="footer">&copy; {ano} - VELLOWARE</footer>;
};

export default Footer;
